import { BUY_EMAIL_HREF } from "../../data/buy";

function DigitalIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="18" height="14" rx="2" />
      <path d="M8 21h8M12 17v4" />
      <circle cx="9" cy="9" r="1.6" />
      <path d="m21 14-4.5-4.5L9 17" />
    </svg>
  );
}

function PrintIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="4" y="3" width="16" height="18" rx="1" />
      <line x1="8" y1="7" x2="16" y2="7" />
      <line x1="8" y1="17" x2="13" y2="17" />
    </svg>
  );
}

function FrameIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="1" />
      <rect x="7" y="7" width="10" height="10" rx="0.5" />
    </svg>
  );
}

const SECTION_ICONS = {
  digital: DigitalIcon,
  print: PrintIcon,
  frame: FrameIcon,
};

/**
 * @param {{ section: import("../../data/buy").BUY_PRODUCT_SECTIONS[number] }} props
 */
export default function BuyProductSection({ section }) {
  const Icon = SECTION_ICONS[section.icon];

  return (
    <section className="buy-section" aria-labelledby={`buy-section-${section.key}`}>
      <div className="buy-section__layout">
        <div className="buy-section__intro">
          <div className="buy-section__meta">
            <span className="buy-section__number">{section.number}</span>
            <span className="buy-section__icon">
              <Icon />
            </span>
          </div>
          <h2 id={`buy-section-${section.key}`} className="buy-section__title">
            {section.title}
          </h2>
          <p className="buy-section__description">{section.description}</p>
        </div>

        {section.pricingNote ? (
          <div className="buy-section__pricing-note">
            <p>{section.pricingNote}</p>
            <a href={BUY_EMAIL_HREF} className="buy-section__pricing-link">
              Contact me for a quote
            </a>
          </div>
        ) : (
          <div
            className={`buy-section__cards buy-section__cards--${section.cardGrid}`}
          >
            {section.cards.map((card) => (
              <div key={card.label} className="buy-price-card">
                <div className="buy-price-card__label">{card.label}</div>
                <div className="buy-price-card__detail">{card.detail}</div>
                <div className="buy-price-card__price">{card.price}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
